module.exports = __webpack_public_path__ + "media/images/home/mountains-bg-90852f45581d394c08141fa1930be883.png";